import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../../../../components/ui/dialog';
import { Button } from '../../../../components/ui/button';
import { Users } from 'lucide-react';
import { InvestorPicker } from '../../../../components/InvestorPicker';

export const ReassignBankInvestorDialog = ({
  open,
  onOpenChange,
  reassignInvestor,
  setReassignInvestor,
  reconInvestors,
  selectedReconBank,
  handleReassignBank,
  reassignLoading,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md" data-testid="reassign-investor-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Users className="h-5 w-5 text-indigo-600" />
          Reassign {selectedReconBank.size} Bank Txn(s) to Investor
        </DialogTitle>
        <DialogDescription>
          Use this when a shared bank account was historically used for multiple investors.
          Tick the affected bank rows, pick the correct investor here, and the rows will
          be re-pointed so allocations match against the right book entries going forward.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3 py-2">
        <div className="text-xs text-slate-500">Search by investor name or RP code (e.g. <span className="font-mono">18-00</span>).</div>
        <InvestorPicker
          value={reassignInvestor}
          onChange={setReassignInvestor}
          investors={reconInvestors}
          includeAll={false}
          placeholder="Pick investor…"
          className="w-full"
          testId="reassign-investor-picker"
        />
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="reassign-cancel-btn">Cancel</Button>
        <Button
          onClick={handleReassignBank}
          disabled={!reassignInvestor || reassignLoading || selectedReconBank.size === 0}
          className="bg-indigo-600 hover:bg-indigo-700 text-white"
          data-testid="reassign-confirm-btn"
        >
          {reassignLoading ? 'Reassigning…' : `Reassign ${selectedReconBank.size}`}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
